import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useRef } from "react"

import { useIntersection } from "helpers/use-intersection"

const IntersectionWrapper = ({ children, disabled = false, ...props }) => {
  const ref = useRef()
  const inViewport = useIntersection(ref, "200px")
  return (
    <Box minHeight="50px" ref={ref} {...props}>
      {(disabled || inViewport) && children}
    </Box>
  )
}

IntersectionWrapper.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
}

export default IntersectionWrapper
